<template>
    <div class="object-mock">
        <top-tip text="演示数据仅用于产品演示和体验，只提供基本的响应保障，请勿用于商用；仅支持主干开发模式，开启多分支功能后失效。" />
        <div class="container">
            <div class="header">
                <hc-button class="add-btn" icon="el-icon-plus" @click="openMockDialog">
                    新建演示数据
                </hc-button>
            </div>
            <hc-table ref="mockTable" v-loading="loading.table" :data="mockData">
                <div slot="empty" class="table-empty">
                    <empty>
                        <span slot="tip">
                            暂无演示数据，
                            <hc-button type="text" @click="openMockDialog">
                                立即创建
                            </hc-button>
                        </span>
                    </empty>
                </div>
                <hc-table-column prop="title" label="所属业务对象" />
                <hc-table-column label="操作">
                    <template slot-scope="{ row }">
                        <hc-button type="text" @click="openEditMockDialog(row)">
                            修改演示数据
                        </hc-button>
                        <hc-button type="text" @click="handleDelete(row)">
                            清空演示数据
                        </hc-button>
                    </template>
                </hc-table-column>
            </hc-table>
            <div v-if="filterObj.total > 10" class="pagination-wrapper">
                <hc-pagination
                    class="pagination-wrapper has-top-border"
                    :current-page.sync="filterObj.page"
                    :page-size="filterObj.pageSize"
                    layout="total, prev, pager, next, sizes, jumper"
                    :total="filterObj.total"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                />
            </div>
        </div>
        <mock-dialog
            :visible="visible.mockDialog"
            @success="mockDialogSuccessCb"
            @close="closeMockDialog"
        />
        <edit-mock-data-dialog
            :object-id="currentObjectId"
            :visible="visible.editMockData"
            @close="closeEditMockDialog"
        />
    </div>
</template>
<script>
import { mapActions } from 'vuex'

import { APP_RESOURCE } from '@common/store/module-types'
import * as T from '@common/store/app-resource/types'
import Empty from '@common/components/empty'
import TopTip from '@common/components/common/top-tip'

import MockDialog from './dialog/mock-data/index'
import editMockDataDialog from './dialog/mock-data/edit-mock-data'

export default {
    name: 'Mock',
    components: {
        Empty,
        TopTip,
        MockDialog,
        editMockDataDialog,
    },
    data() {
        return {
            loading: {
                table: false,
            },
            mockData: [],
            filterObj: {
                // keyword: '',
                // groupId: '',
                page: 1,
                pageSize: 10,
                total: 0,
            },
            visible: {
                mockDialog: false,
                editMockData: false,
            },
            // 当前点击演示数据的 objectId
            currentObjectId: '',
        }
    },
    created() {
        this.getList()
    },
    methods: {
        ...mapActions(APP_RESOURCE, {
            getMockList: T.GET_MOCK_LIST,
            deleteMockItem: T.DELETE_MOCK_ITEM,
        }),
        openEditMockDialog(row) {
            this.currentObjectId = row.id
            this.visible.editMockData = true
        },
        closeEditMockDialog() {
            this.visible.editMockData = false
        },
        openMockDialog() {
            this.visible.mockDialog = true
        },
        closeMockDialog() {
            this.visible.mockDialog = false
        },
        mockDialogSuccessCb() {
            this.closeMockDialog()
            this.filterObj.page = 1
            this.getList()
        },
        async getList() {
            this.loading.table = true
            const data = await this.getMockList(this.filterObj)
            this.loading.table = false
            if (data && data.items) {
                this.mockData = data.items
                this.filterObj.total = data.total
            }
        },
        handleSizeChange(val) {
            this.$set(this.filterObj, 'pageSize', val)
            this.getList()
        },
        handleCurrentChange(val) {
            this.$set(this.filterObj, 'page', val)
            this.getList()
        },
        handleDelete(item) {
            const { id } = item
            this.$confirm('清空后无法恢复，确定清空？', {
                type: 'warning',
                title: '清空演示数据',
                roundButton: false,
            })
                .then(async () => {
                    try {
                        await this.deleteMockItem(id)
                        this.$message.success('删除成功')
                        this.getList()
                        // eslint-disable-next-line no-empty
                    } catch (error) {}
                })
        },
    },
}
</script>
<style lang="less" scoped>
.object-mock {
    .container {
        margin: 16px;
        background: #fff;
        padding: 0 16px;
        .header {
            display: flex;
            padding: 8px 0;
            justify-content: flex-end;
            .add-btn {
                color: #266eff;
                border-color: #266eff;
            }
        }
        /deep/ .hc-table th.hc-table__cell{
            background: #FBFBFB;
        }
        .table-empty,
        .hc-table {
            .hc-button {
                background: none;
            }
        }
    }
}
</style>
